/* ==========================================================================
   CLARA cart drawer — ongoing text & content settings
   >>> EDIT THE VALUES IN CLARA_CART_TEXTS BELOW ANY TIME. No other file needed.
   Loaded (deferred) in layout/theme.liquid BEFORE assets/clark-cart-upsells.js.
   ========================================================================== */
var CLARA_CART_TEXTS = {
  /* Heading above the recommendations in the cart drawer */
  recsTitle: 'You may also like',
  /* Rotating messages in the notice strip at the top of the drawer (2+ shows < > arrows) */
  deliveryMessages: [
    'Next-day delivery available in Karachi. DC: Rs. 400',
    'Free shipping on order above Rs. 3,500'
  ],
  /* Pin ONE product FIRST in "You may also like": paste its handle here
     (the part after /products/ in its URL, e.g. 'gold-plated-bracelet').
     Leave empty ('') to turn pinning off. */
  recsPinHandle: 'clara-box'
};

(function () {
  /* The upsells engine declares `var CLARK_UPSELLS = {...defaults}` when it runs,
     which would wipe a plain pre-set object — so intercept that assignment and
     merge our values over its defaults. */
  var merged;
  try {
    Object.defineProperty(window, 'CLARK_UPSELLS', {
      configurable: true,
      get: function () { return merged; },
      set: function (defaults) { merged = Object.assign({}, defaults, CLARA_CART_TEXTS); }
    });
  } catch (e) {
    window.CLARK_UPSELLS = CLARA_CART_TEXTS;
  }

  /* Pin-to-front for "You may also like": inject the pinned product at the top of
     the engine's recommendation fetches (and its collection fallback). The engine
     still skips it if it is already in the cart or unavailable. */
  var PIN = String(CLARA_CART_TEXTS.recsPinHandle || '').trim().replace(/^\/+|\/+$/g, '');
  if (!PIN) return;
  var _fetch = window.fetch.bind(window);
  var pinnedPromise = null;
  var pinUrl = '/products/' + encodeURIComponent(PIN) + '.js';
  function getPinned() {
    if (!pinnedPromise) {
      pinnedPromise = _fetch(pinUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return pinnedPromise;
  }
  function isRecsCall(u) {
    return u.indexOf('/recommendations/products.json') > -1 ||
           /\/collections\/[^\/]+\/products\.json(\?|$)/.test(u);
  }
  window.fetch = function (url, opts) {
    var u = String((url && url.url) || url || '');
    if (!isRecsCall(u)) return _fetch(url, opts);
    return Promise.all([
      _fetch(url, opts).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }),
      getPinned()
    ]).then(function (parts) {
      var list = ((parts[0] && parts[0].products) || []).slice();
      var pinned = parts[1];
      if (pinned && pinned.id) {
        list = list.filter(function (p) { return p && p.id !== pinned.id; });
        list.unshift(pinned);
      }
      return { ok: true, status: 200, json: function () { return Promise.resolve({ products: list }); } };
    });
  };
})();
